import React, { Suspense } from 'react';
import Hidden from '@mui/material/Hidden';
import { lazy } from '@loadable/component';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

const DesktopNavbar = lazy(() => import('./navbar/DesktopNavbar'));
const MobileNavbar = lazy(() => import('./navbar/MobileNavbar'));

const LucilaNavbar = () => {
  const theme = useTheme();
  const { navbarHeight } = theme.components.MuiToolbar;
  return (
    <Suspense fallback={<Box sx={{ minHeight: navbarHeight }} />}>
      <Hidden mdUp>
        <MobileNavbar />
      </Hidden>
      <Hidden mdDown>
        <DesktopNavbar />
      </Hidden>
    </Suspense>
  );
};

export default LucilaNavbar;
